import validator from 'validator';
import PhoneUtil from 'shared/util/phoneutil';

export default function isPhoneOrEmail(values, value) {
  return PhoneUtil.isValidNumber(value) || validator.isEmail(value || '');
}
